var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewproducts1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1441 4.86942C10.7117 4.86942 10.3604 4.51807 10.3604 4.08564V2.12167C10.3604 1.68924 10.7117 1.33789 11.1441 1.33789H22.5225C22.9549 1.33789 23.3063 1.68924 23.3063 2.12167V4.08113C23.3063 4.51357 22.9549 4.86492 22.5225 4.86492",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61719 8.00878V7.61689C7.61719 6.09887 8.84692 4.86914 10.3649 4.86914H12.3244",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4637 4.86914H22.9186C24.4366 4.86914 25.6664 6.09887 25.6664 7.61689V22.9187C25.6664 24.4367 24.4366 25.6664 22.9186 25.6664H13.1123",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7031 20.1715H17.8202C17.1716 20.1715 16.6445 19.6445 16.6445 18.9959V11.5409C16.6445 10.8923 17.1716 10.3652 17.8202 10.3652H23.7031",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2842 8.00977H23.7031",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2842 22.5234H23.7031",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12167 10.3613H10.3604C10.7928 10.3613 11.1442 10.7127 11.1442 11.1451V13.1046H1.33789V11.1451C1.33789 10.7127 1.68924 10.3613 2.12167 10.3613Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.752 15.0684V24.4828C10.752 25.1314 10.225 25.6585 9.57634 25.6585H2.90517C2.25652 25.6585 1.72949 25.1314 1.72949 24.4828V15.0684",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewproducts1);
export default __webpack_public_path__ + "static/media/newproducts1.d4a13a8b2b7afa6dcfee86d08afc3589.svg";
export { ForwardRef as ReactComponent };